import { Component, OnInit, Inject, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService, ConstantsService, LookupsService, AccountService } from '@app/core/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { triggerFormValidation, focusFirstInvalidField } from '@app/shared/functions';
import { BuilderService } from '@app/modules/builder/base/services';
import { SocoHttpService } from '@app/soco/http';
import { UspsService } from '@app/shared/services';
import { DatePipe } from '@angular/common';
import { BuilderInfoOne } from '@app/core/models';

declare var swal: any;
require('sweetalert');

interface SubName {
  id: number;
  itemName: string;
}

@Component({
  selector: 'app-add-subsidiary',
  templateUrl: './add-subsidiary.component.html',
  styleUrls: ['./add-subsidiary.component.css']
})
export class AddSubsidiaryComponent implements OnInit {  
  public builderSearchForm: FormGroup;
  public addSubsidiaryForm: FormGroup;
  userForm: FormGroup;
  public submitFlag;
  addNewUser: any = {};
  public flag = false;
  subList: SubName[];
  builderId: string;
  public addNewBuilder: BuilderInfoOne = {
    reEnterEmail : null,
    id: null,
    IsActive: null,
    _companyName: null,
    companyName: null,
    builderTypeCode: null,
    email: null,
    status: null,
    recCreateDate: null,
    recCreateUserId: null,
    recUpdateDate: null,
    recUpdateUserId: null,
    builderUsers: null,
    builderMapping: null,
    builderAddresses: {
      id: null,
      contactTypeCode: null,
      streetNumber: null,
      streetName: null,
      directionPrefix: null,
      directionSuffix: null,
      streetType: null,
      city: null,
      state: null,
      zipCode: null,
      contactName2Extn: null,
      contactName1Extn: null,
      contactName1Phone: null,
      contactName1AreaCode: null,
      contactName2AreaCode: null,
      contactName2Phone: null,
      address2: null,
      unitNumber: null,
      recUpdatedDate: null,
    recCreatedDate: null,
    recCreatedBy: null,
    recUpdatedBy: null
    }
  };
  public notFound;
 public _builderData: any = {};
  public subsidiaryInput: any = {};
  cities: any = [];
  states: any = [];
  public builderInfo: any = {};
  // builderCompanySearch: any = {
  //   builderCompanyName: null,
  //   builderAddress: null,
  //   phone: null,
  //   extension: null,
  //   email: null,
  //   activeCompany: false
  //    };
  constructor(
    @Inject(Router) private router: Router,
    public session: SessionService,
    private builderSvc: BuilderService,
    public socoHttp: SocoHttpService,
    public constantsSvc: ConstantsService,
    public lookupSvc: LookupsService,
    private usps: UspsService,
    public accountSvc: AccountService,
    private datePipe: DatePipe,
  ) {
    this.session.builderData.subscribe(result => {
      if (result) {
        this.socoHttp.hidePleaseWait('ContainerAwaiter1');
        this.builderId = result.BuilderId[0];
        this.subList = [];
        this.subList.push({ id: +this.builderId, itemName: result.CompanyName });
        for ( const i of result.BuilderMapping ) {
          if ( i.status === 'Approved' ) {
            this.subList.push({ id: +i.subsidiaryId, itemName: i.subsidiaryName.toString()});
          }
        }
      } else {  
        if(this.accountSvc.account.user.company !== undefined && this.accountSvc.account.user.company !== null ){
        this.builderSvc.getBuilderInfo(this.accountSvc.account.user.company).subscribe(
          result => {
            if (result.data !== undefined && result !== null  && result.data.length !== 0) {
              this.builderId = result.data.id;
              this.subList = [];
              this.subList.push({ id: +this.builderId, itemName: this.accountSvc.account.user.company });
              for ( const i of result.data.builderMapping ) {
                if ( i.status === 'Approved' ) {
                this.subList.push({ id: +i.subsidiaryId, itemName: i.subsidiaryName.toString() });
                }
            }
          }
          });}
        }      
      },
      error => {
        this.socoHttp.hidePleaseWait('ContainerAwaiter1');
      });
  }
  @Input() set builderdata(data: any) {
    this._builderData = data;
  }
  @Output() updateSubsidiary = new EventEmitter<any>();

  ngOnInit() {
    if (!this._builderData.builderId) {
      this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter2');
    this.session.builderData.subscribe(result => {
      if (result) {
        this.socoHttp.hidePleaseWait('ContainerAwaiter2');
        this.builderInfo.builderId = result.BuilderId[0];
        this.builderInfo.companyName = result.CompanyName;
        this.addSubsidiary();
        this.resolveZipCode();        
      } else {
        this.builderSvc.getBuilderInfo(this.accountSvc.account.user.company).subscribe(
          result => {
            if (result.data !== undefined && result.data.length !== 0) {
              this.builderInfo.builderId = result.data.id;
              this.builderInfo.companyName = result.data.companyName;
    }
    this.addSubsidiary();
    this.resolveZipCode();
  });  
      }
      },
      error => {
        this.socoHttp.hidePleaseWait('ContainerAwaiter2');
        this.addSubsidiary();
        this.resolveZipCode();
      });
    } else {
      this.addSubsidiary();
      this.resolveZipCode();
    }
    this.cities = this.lookupSvc.cities;
    this.states = this.lookupSvc.states;
    }
  checkForBuilder() {
    if (this.addSubsidiaryForm.valid) {
      if (this.userForm.valid) {
const builderName = this.addSubsidiaryForm.controls['builderName'].value;
this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter2');
this.builderSvc.getBuilderDetails(builderName).subscribe(res => {  
  if ((res.data === undefined || res.data === null) && res.statusCode === 200) {
  this.submitForm();    
} else {
  this.socoHttp.hidePleaseWait('ContainerAwaiter2');
  this.builderSvc.builderInfoSub.BuilderId = res.data.id;
  this.builderSvc.builderInfoSub.CompanyName = res.data.companyName;
  this.builderSvc.builderInfoSub.CompanyEmail = res.data.email;
  this.builderSvc.builderInfoSub.IsActive = res.data.isActive;
  this.builderSvc.builderInfoSub.CompanyAddress = res.data.builderAddresses;
  swal(this.constantsSvc.warningSwal, this.constantsSvc.builderCompanySubsidiaryAddWarning, this.constantsSvc.warningSwal);
  this.OnClose();
}
},
error => {
  this.notFound = true;
    this.submitForm();
});
    } else {
      triggerFormValidation(this.userForm);
      focusFirstInvalidField(this.userForm);
    }
    } else {
      triggerFormValidation(this.addSubsidiaryForm);
      focusFirstInvalidField(this.addSubsidiaryForm);
    }

  }


  // Code to populate city and state values based on zip code entered
  resolveZipCode() {
    this.addSubsidiaryForm.controls['zipCode'].valueChanges.subscribe(selectedValue => {
      if (this.constantsSvc.zipCodePattern.test(selectedValue)) { // We have a valid ZIP Code.
        this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter2');
        this.usps.GetCityStateFromZip(selectedValue, (result) => {
          if (result.CityStateLookupResponse.ZipCode.Error) {
            this.addSubsidiaryForm.patchValue({ city: null, state: null, zipCode: null });
            this.socoHttp.hidePleaseWait('ContainerAwaiter2');
            swal(this.constantsSvc.invalidZipSwal, '', this.constantsSvc.errorSwal);
            return;
          }
          this.lookupSvc.loadMailingAddressCityLookups(result.CityStateLookupResponse.ZipCode.State,
            result.CityStateLookupResponse.ZipCode.City);
          this.lookupSvc.mailingAddressLookupsLoaded$.subscribe(loaded => {
            if (loaded) {
              this.socoHttp.hidePleaseWait('ContainerAwaiter2');
              this.cities = this.lookupSvc.mailingCity;
              this.states = this.lookupSvc.mailingState;
              this.addSubsidiaryForm.patchValue({
                city: this.lookupSvc.mailingCity.length > 0 ? this.lookupSvc.mailingCity[0] : null,
                state: this.lookupSvc.mailingState.length > 0 ? this.lookupSvc.mailingState[0] : null,
              });
            }
          }, fail => { this.socoHttp.hidePleaseWait('ContainerAwaiter2'); });
        });
      }
    });
  }
   // On click of cancel event reset the FromGroup
   OnClose() {    
    $('#modal_add_subsidiary').modal('hide');
    this.addSubsidiaryForm.reset();
    this.userForm.reset();
    this.addSubsidiaryForm.patchValue({
      subsidaryCompany: this._builderData.companyName ?
      this._builderData.companyName : this.builderInfo.builderId
    });
    this.addSubsidiaryForm.controls['subsidaryCompany'].reset();
    this.addSubsidiaryForm.updateValueAndValidity();
    this.builderSvc.builderInfoSub.BuilderId = null;
  this.builderSvc.builderInfoSub.CompanyName = null;
  this.builderSvc.builderInfoSub.CompanyEmail = null;
  this.builderSvc.builderInfoSub.IsActive = null;
  this.builderSvc.builderInfoSub.CompanyAddress.contactTypeCode = null;
  this.builderSvc.builderInfoSub.CompanyAddress.recUpdatedBy = null;
  this.builderSvc.builderInfoSub.CompanyAddress.recCreatedBy = null;
  this.builderSvc.builderInfoSub.CompanyAddress.recCreatedDate = null;
  this.builderSvc.builderInfoSub.CompanyAddress.id = null;
  this.builderSvc.builderInfoSub.CompanyAddress.contactName1Extn = null;
  this.builderSvc.builderInfoSub.CompanyAddress.contactName1Phone = null;
  this.builderSvc.builderInfoSub.CompanyAddress.contactName2Extn = null;
  this.builderSvc.builderInfoSub.CompanyAddress.recUpdatedDate = null;
  this.builderSvc.builderInfoSub.CompanyAddress.city = null;
  this.builderSvc.builderInfoSub.CompanyAddress.streetName = null;
  this.builderSvc.builderInfoSub.CompanyAddress.streetNumber = null;
  this.builderSvc.builderInfoSub.CompanyAddress.streetType = null;
  this.builderSvc.builderInfoSub.CompanyAddress.state = null;
  this.builderSvc.builderInfoSub.CompanyAddress.zipCode = null;
  this.builderSvc.builderInfoSub.CompanyAddress.unitNumber = null;
  this.builderSvc.builderInfoSub.CompanyAddress.directionPrefix = null;
  this.builderSvc.builderInfoSub.CompanyAddress.directionSuffix = null;
  this.addSubsidiaryForm.controls['subsidaryCompany'].reset();
  }
  addSubsidiary() {
    this.flag = true;
    this.addSubsidiaryForm = new FormGroup({
      subsidaryCompany: new FormControl(null, Validators.required),
      parentBuilderName: new FormControl({ value: (this._builderData.companyName ?
          this._builderData.companyName : this.builderInfo.companyName), disabled: true }),
      builderName: new FormControl(null, [Validators.required, Validators.maxLength(70)]),
      streetNumber: new FormControl(null,
        [Validators.required, Validators.maxLength(7), Validators.pattern(this.constantsSvc.numericPatternwithZero)]),
      streetName: new FormControl(null, [Validators.required,  Validators.maxLength(60)]),
      city: new FormControl({ value: null, disabled: true }),
      state: new FormControl({ value: null, disabled: true }),
      zipCode: new FormControl(null,
        [Validators.required, Validators.pattern(this.constantsSvc.zipCodePattern)]),
      phone: new FormControl(null,
        [Validators.required, Validators.pattern(this.constantsSvc.phoneNumberPattern)]),
      phoneExt: new FormControl(null,
        [Validators.pattern(this.constantsSvc.phoneNumberExtensionPattern), Validators.maxLength(6)]),
      email: new FormControl(null,
        [Validators.required, Validators.maxLength(50), Validators.pattern(this.constantsSvc.emailPattern)])
    });

    this.userForm = new FormGroup({
      firstName: new FormControl(
        null,
        [Validators.required, Validators.maxLength(50)]
      ),
      lastName: new FormControl(
        null,
        [Validators.required, Validators.maxLength(50)]
      ),
      email: new FormControl(
        null,
        [Validators.required, Validators.maxLength(50), Validators.pattern(this.constantsSvc.emailPattern)]
      ),
      contactNumber: new FormControl(
        null,
        [Validators.required, Validators.pattern(this.constantsSvc.phoneNumberPattern)]
      )
    });
  }

  addUser() {
    this.addNewUser.id = this.subsidiaryInput.SubsidiaryId;
    this.addNewUser.userId = this.userForm.controls['email'].value;
    this.addNewUser.userName = this.userForm.controls['firstName'].value + ' ' + this.userForm.controls['lastName'].value;
    this.addNewUser.firstName = this.userForm.controls['firstName'].value;
    this.addNewUser.lastName = this.userForm.controls['lastName'].value;
    this.addNewUser.email = this.userForm.controls['email'].value;
    this.addNewUser.Status = 'Requested';
    this.addNewUser.communicationTypeCd = null;
    this.addNewUser.iaAdmin = null;
    this.addNewUser.recCreatedDate = this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
    this.addNewUser.recUpdatedDate = this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
    this.addNewUser.recCreatedBy =  this.userForm.controls['email'].value;
    this.addNewUser.recUpdatedBy = this.userForm.controls['email'].value;
    this.addNewUser.contactName2Phone = this.userForm.controls['contactNumber'].value;
    this.addNewUser.contactName2Extn = null;
    this.addNewUser.comments = null;
    this.addNewUser.approveRejectDTTM = null;
    this.addNewUser.approveRejectBy = null;
    this.builderSvc.addUser(this.addNewUser).subscribe(result => {
      if (result.data.companyName === '') {
        swal(this.constantsSvc.warningSwal, this.constantsSvc.builderUserAddWarning, this.constantsSvc.warningSwal);
        this.socoHttp.hidePleaseWait('ContainerAwaiter2');
      } else {
        this.socoHttp.hidePleaseWait('ContainerAwaiter2');        
        $('#modal_add_subsidiary').modal('hide');
        this.addSubsidiaryForm.reset();
        this.userForm.reset();
        this.addSubsidiaryForm.patchValue({
          subsidaryCompany: this._builderData.companyName ?
          this._builderData.companyName : this.builderInfo.builderId
        });
        this.addSubsidiaryForm.updateValueAndValidity();
        this.updateSubsidiary.emit('true');
        swal(this.constantsSvc.successSwal1, this.constantsSvc.subsidiaryAddSuccess, this.constantsSvc.successSwal);   
        this.addSubsidiaryForm.controls['subsidaryCompany'].reset();     
      }
    }, error => {
      this.socoHttp.hidePleaseWait('ContainerAwaiter2');
      swal(this.constantsSvc.errorSwal1, this.constantsSvc.subsidiaryAddFail, this.constantsSvc.errorSwal);
    });

  }


  submitForm() {
        const userId = this.accountSvc.account.user.username;
        this.addNewBuilder._companyName = this.addSubsidiaryForm.controls['builderName'].value.trim();
        this.addNewBuilder.companyName = this.addSubsidiaryForm.controls['builderName'].value.trim();
        this.addNewBuilder.email = this.addSubsidiaryForm.controls['email'].value;
        this.addNewBuilder.status = 'Approved';
        this.addNewBuilder.recCreateDate = (this.builderSvc.builderInfoSub.CompanyAddress.recCreatedDate !== null) ?
        this.builderSvc.builderInfoSub.CompanyAddress.recCreatedDate :
        this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
        this.addNewBuilder.recUpdateDate = this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
        this.addNewBuilder.recCreateUserId = this.builderSvc.builderInfoSub.CompanyAddress.recCreatedBy ?
        this.builderSvc.builderInfoSub.CompanyAddress.recCreatedBy : userId;
        this.addNewBuilder.recUpdateUserId = userId;
        this.addNewBuilder.builderAddresses.recCreatedDate = (this.builderSvc.builderInfoSub.CompanyAddress.recCreatedDate !== null) ?
        this.builderSvc.builderInfoSub.CompanyAddress.recCreatedDate :
        this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
        this.addNewBuilder.builderAddresses.recUpdatedDate =
         this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
        this.addNewBuilder.builderAddresses.recCreatedBy = this.builderSvc.builderInfoSub.CompanyAddress.recCreatedBy ?
        this.builderSvc.builderInfoSub.CompanyAddress.recCreatedBy : userId;
        this.addNewBuilder.builderAddresses.recUpdatedBy = userId;
        this.addNewBuilder.IsActive = 'Y';
        this.addNewBuilder.builderAddresses.contactTypeCode = (this.builderSvc.builderInfoSub.CompanyAddress.contactTypeCode !== null) ?
        this.builderSvc.builderInfoSub.CompanyAddress.contactTypeCode : this.constantsSvc.contactTypeCode;
        this.addNewBuilder.builderAddresses.id = this.builderSvc.builderInfoSub.CompanyAddress.id ?
        this.builderSvc.builderInfoSub.CompanyAddress.id : null;
        this.addNewBuilder.id = this.builderSvc.builderInfoSub.CompanyAddress.id ? this.builderSvc.builderInfoSub.CompanyAddress.id : null;
        this.addNewBuilder.builderAddresses.state = this.addSubsidiaryForm.controls['state'].value ?
        this.addSubsidiaryForm.controls['state'].value.id : null;
        this.addNewBuilder.builderAddresses.city = this.addSubsidiaryForm.controls['city'].value ?
        this.addSubsidiaryForm.controls['city'].value.id : null;
        this.addNewBuilder.builderAddresses.zipCode = this.addSubsidiaryForm.controls['zipCode'].value;
        this.addNewBuilder.builderAddresses.streetName = this.addSubsidiaryForm.controls['streetName'].value.trim();
        this.addNewBuilder.builderAddresses.streetNumber = this.addSubsidiaryForm.controls['streetNumber'].value.trim();
        this.addNewBuilder.builderAddresses.contactName1Extn = this.builderSvc.builderInfoSub.CompanyAddress.contactName1Extn ?
        this.builderSvc.builderInfoSub.CompanyAddress.contactName1Extn : this.addSubsidiaryForm.controls['phoneExt'].value;
        this.addNewBuilder.builderAddresses.contactName1Phone = this.addSubsidiaryForm.controls['phone'].value;
        this.addNewBuilder.builderAddresses.address2 = this.addSubsidiaryForm.controls['streetNumber'].value + ' ' +
        this.addSubsidiaryForm.controls['streetName'].value + ', ' + this.addSubsidiaryForm.controls['city'].value.itemName + ', ' +
        this.addSubsidiaryForm.controls['state'].value.itemName + ' ' + this.addSubsidiaryForm.controls['zipCode'].value;


        this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter2');
        this.builderSvc.addBuilder(this.addNewBuilder).subscribe(res => {
          this.subsidiaryInput._SubsidiaryName = res.data._companyName;
          this.subsidiaryInput.SubsidiaryName = res.data.companyName;
          this.subsidiaryInput.SubsidiaryId = res.data.id;
          this.subsidiaryInput.Id = this.addSubsidiaryForm.controls['subsidaryCompany'].value['id'];
          this.subsidiaryInput.Status = this.constantsSvc.Requested;
          this.subsidiaryInput.RecCreatedBy = userId;
          this.subsidiaryInput.RecUpdatedBy = userId;
          this.subsidiaryInput.RecCreatedDate = this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
          this.subsidiaryInput.RecUpdatedDate = this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
          this.subsidiaryInput.BuilderName = this.addSubsidiaryForm.controls['subsidaryCompany'].value['itemName'];
          this.builderSvc.updateBuilderMapping(this.subsidiaryInput).subscribe(res => {
            this.builderSvc.subsidiaryId.subsidiaryId = this.subsidiaryInput.SubsidiaryId;
            this.builderSvc.subsidiaryId.status = this.constantsSvc.Requested;
            this.addUser();
          },
          error => {
            this.socoHttp.hidePleaseWait('ContainerAwaiter2');
            swal(this.constantsSvc.errorSwal1, this.constantsSvc.subsidiaryAddFail, this.constantsSvc.errorSwal);
          });
      },
      error => {
        this.socoHttp.hidePleaseWait('ContainerAwaiter2');
        swal(this.constantsSvc.errorSwal1, this.constantsSvc.subsidiaryAddFail, this.constantsSvc.errorSwal);
      });      
}
}
